import { createContext, useContext } from 'react'

export interface SeoReportAnalyticsCallbacks {
  onProductClick: (params: {
    productSlug: string
    productName: string
    outboundUrl: string
    price: number | null
    position: number
    section: string
  }) => void
  onRelatedClick: (params: {
    targetSlug: string
    targetTitle: string
    position: number
  }) => void
}

const SeoReportAnalyticsContext =
  createContext<SeoReportAnalyticsCallbacks | null>(null)

export const SeoReportAnalyticsProvider = SeoReportAnalyticsContext.Provider

export function useSeoReportAnalytics(): SeoReportAnalyticsCallbacks | null {
  return useContext(SeoReportAnalyticsContext)
}
